import moment from 'moment';
import { Button } from 'react-bootstrap';
import { TransportOrdersFilters as TransportOrdersFiltersType } from '../../domain/transportOrdersFilters';
import { useLoggedInUser } from '../users/LoggedInUserProvider';

type TransportOrdersQuickFiltersProps = {
    filters: TransportOrdersFiltersType;
    onFiltersChange: (filters: TransportOrdersFiltersType | undefined) => void;
}

const now = moment();
const currentMonth = now.month() + 1;
const currentYear = now.year();

const pastMonthDate = now.clone().subtract(1, 'months');
const pastMonth = pastMonthDate.month() + 1;
const pastMonthYear = pastMonthDate.year();


const nextMonthDate = now.clone().add(1, 'months');
const nextMonth = nextMonthDate.month() + 1;
const nextMonthYear = nextMonthDate.year();

export const TransportOrdersQuickFilters = ({ filters, onFiltersChange }: TransportOrdersQuickFiltersProps) => {
    const { loggedInUser } = useLoggedInUser();

    const isCurrentDispatcher = filters.creator?.id === loggedInUser.sub;

    const isCurrentMonth =
        filters.orderMonthYearRange?.fromMonth === currentMonth &&
        filters.orderMonthYearRange?.fromYear === currentYear &&
        filters.orderMonthYearRange?.toMonth === currentMonth &&
        filters.orderMonthYearRange?.toYear === currentYear;
    const isPastMonth =
        filters.orderMonthYearRange?.fromMonth === pastMonth &&
        filters.orderMonthYearRange?.fromYear === pastMonthYear &&
        filters.orderMonthYearRange?.toMonth === pastMonth &&
        filters.orderMonthYearRange?.toYear === pastMonthYear;
    const isNextMonth =
        filters.orderMonthYearRange?.fromMonth === nextMonth &&
        filters.orderMonthYearRange?.fromYear === nextMonthYear &&
        filters.orderMonthYearRange?.toMonth === nextMonth &&
        filters.orderMonthYearRange?.toYear === nextMonthYear;

    const handleYourOrdersClick = () => {
        if (isCurrentDispatcher) {
            onFiltersChange({
                ...filters,
                creator: undefined,
            });
        } else {
            onFiltersChange({
                ...filters,
                creator: {
                    id: loggedInUser.sub,
                },
            });
        }
    };

    const handleCurrentMonthClick = () => {
        if (isCurrentMonth) {
            onFiltersChange({
                ...filters,
                orderMonthYearRange: undefined,
            })
        } else {
            onFiltersChange({
                ...filters,
                orderMonthYearRange: {
                    fromMonth: currentMonth,
                    fromYear: currentYear,
                    toMonth: currentMonth,
                    toYear: currentYear,
                },
            });
        }
    };

    const handlePastMonthClick = () => {
        if (isPastMonth) {
            onFiltersChange({
                ...filters,
                orderMonthYearRange: undefined,
            })
        } else {
            onFiltersChange({
                ...filters,
                orderMonthYearRange: {
                    fromMonth: pastMonth,
                    fromYear: pastMonthYear,
                    toMonth: pastMonth,
                    toYear: pastMonthYear,
                },
            });
        }
    };

    const handleNextMonthClick = () => {
        if (isNextMonth) {
            onFiltersChange({
                ...filters,
                orderMonthYearRange: undefined,
            })
        } else {
            onFiltersChange({
                ...filters,
                orderMonthYearRange: {
                    fromMonth: nextMonth,
                    fromYear: nextMonthYear,
                    toMonth: nextMonth,
                    toYear: nextMonthYear,
                },
        });
        }
    };

    return (
        <ul className="d-flex flex-row list-unstyled">
            <li className="me-2">
                <Button onClick={handleYourOrdersClick} variant={isCurrentDispatcher ? 'primary' : 'outline-primary'}>
                    Twoje zlecenia
                </Button>
            </li>
            <li className="me-2">
                <Button onClick={handleCurrentMonthClick} variant={isCurrentMonth ? 'primary' : 'outline-primary'}>
                    Bieżący miesiąc
                </Button>
            </li>
            <li className="me-2">
                <Button onClick={handlePastMonthClick} variant={isPastMonth ? 'primary' : 'outline-primary'}>
                    Poprzedni miesiąc
                </Button>
            </li>
            <li>
                <Button onClick={handleNextMonthClick} variant={isNextMonth ? 'primary' : 'outline-primary'}>
                    Następny miesiąc
                </Button>
            </li>
        </ul>
    );
};